module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-card', {
    staticClass: "tableInfo"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("banner图配置")])]), _vm._v(" "), _c('el-form', {
    ref: "formparams",
    attrs: {
      "model": _vm.formparams,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    ref: "uploadElement"
  }, [_c('el-upload', {
    ref: "upload",
    attrs: {
      "action": "aa",
      "list-type": "picture-card",
      "auto-upload": false,
      "http-request": _vm.uploadFile,
      "file-list": _vm.fileList,
      "multiple": "",
      "on-remove": _vm.handleRemove,
      "accept": "image/png,image/gif,image/jpg,image/jpeg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v("\n                *提示*：为了更好的用户体验，图片请提供670*340像素，文件大小不超过500kb。\n            ")], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "120px",
      "margin": "20px 0 0 100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-9f137ca2"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/configurable/configurable.vue
// module id = 624
// module chunks = 70